import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { Bold } from "../common/Bold";
import { RowWithBullet } from "../common/RowWithBullet";
export var PayoutCalculationIA = function PayoutCalculationIA() {
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "GoibG8",
    defaultMessage: [{
      "type": 0,
      "value": "Uitbetalingen voor merken op Faire worden berekend met de volgende formule: uitbetalingsbedrag = (subtotaal bestelling) + (vergoeding verzending) - (commissie) - (vergoeding voor betalingsverwerking)"
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement(RowWithBullet, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "UVFpLi",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Subtotaal bestelling"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": ": de cumulatieve wholesalekosten van de artikelen in de bestelling, min eventuele door het merk gefinancierde promoties."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(RowWithBullet, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "EZKlAY",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Verzendvergoeding"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": ": de verzendkosten (alleen van toepassing als de bestelling met je eigen vervoerder wordt verzonden, dus niet via Verzenden met Faire)"
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(RowWithBullet, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "AWOZxu",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Commissie"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": ": subtotaal bestelling x commissiepercentage voor die bestelling"
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(RowWithBullet, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "zNePjD",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Verwerkingskosten voor betalingen"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": ": subtotaal artikelen x vergoeding voor betalingsverwerking"
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  })))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "H3tdjk",
    defaultMessage: [{
      "type": 0,
      "value": "Je kunt een volledige berekening van je uitbetaling zien op het tabblad "
    }, {
      "children": [{
        "type": 0,
        "value": "Bestellingen"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": " door op de pagina met details van de bestelling te klikken. Scroll naar de sectie "
    }, {
      "children": [{
        "type": 0,
        "value": "Je bent uitbetaald."
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": " en selecteer "
    }, {
      "children": [{
        "type": 0,
        "value": "Uitbetalingsoverzicht bekijken"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": ". Daar vind je een gedetailleerd overzicht van de uitbetaling."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  })));
};
var _BoldFormatting = function _BoldFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Bold, null, chunks);
};